
import React from 'react';
import { Button } from '@/components/ui/button';
import { FormFile } from '@/hooks/useFormState';
import FileUploader from '../FileUploader';
import { ArrowLeft, ArrowRight } from 'lucide-react';

interface SupportingDocumentsProps {
  uploadedFiles: FormFile[];
  onNext: () => void;
  onPrev: () => void;
  addFile: (file: FormFile) => void;
  removeFile: (fileName: string) => void;
}

const SupportingDocuments: React.FC<SupportingDocumentsProps> = ({
  uploadedFiles,
  onNext,
  onPrev,
  addFile,
  removeFile,
}) => {
  return (
    <div className="space-y-6 animate-fade-in">
      <div className="space-y-2">
        <h2 className="text-2xl font-bold tracking-tight">Supporting Documents</h2>
        <p className="text-muted-foreground">
          Upload key documents that support your discrimination case. You can add more evidence later for specific discrimination types.
        </p>
      </div>

      <FileUploader
        onFileUploaded={addFile}
        onFileRemoved={removeFile}
        uploadedFiles={uploadedFiles}
        maxFileSize={5}
        maxFiles={5}
        showSupportingDocumentsInfo={true}
      />

      <div className="flex justify-between pt-2">
        <Button
          type="button"
          variant="outline"
          onClick={onPrev}
          className="gap-1"
        >
          <ArrowLeft className="h-4 w-4" />
          Previous
        </Button>
        
        <Button
          type="button"
          onClick={onNext}
          className="gap-1"
        >
          Next
          <ArrowRight className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
};

export default SupportingDocuments;
